export default "__VITE_ASSET__BUWQ5pIm__"